<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">經銷商帳號</h4>
              </div>
              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->

                <el-row :gutter="20">
                  <el-col :xs="24" :md="6">
                    <el-input v-model="filters[0].value" placeholder="搜尋" prefix-icon="el-icon-search"></el-input>
                  </el-col>
                  <el-col :xs="24" :md="6">
                    <router-link to="./si-accounts/new" type="success">
                      <el-button type="success" plain>建立經銷商帳號與管理員</el-button>
                    </router-link>
                  </el-col>
                </el-row>

                <data-tables :data="data" :filters="filters" :action-col="actionCol">
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  ></el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      data: [],
      titles: [
        {
          prop: "id",
          label: "NO."
        },
        {
          prop: "name",
          label: "Name"
        },
        {
          prop: "createdAt",
          label: "建立時間"
        },
        {
          prop: "updatedAt",
          label: "更新時間"
        }
      ],
      actionCol: {
        label: "操作",
        props: {
          align: "center"
        },
        buttons: [
          {
            props: {
              type: "warning",
              icon: "el-icon-edit"
            },
            label: "管理員列表",
            handler: row => {
              console.log("the row is ", row);

              this.$router.push(`/si-accounts/${row.id}/si-users`);
            }
          },
          {
            props: {
              type: "default",
              icon: "el-icon-edit",
              plain: true
            },
            label: "更新名稱",
            handler: row => {
              console.log("START the row is ", row);

              this.$router.push(
                `/si-accounts/${row.id}/edit`)
            }
          },
          {
            props: {
              type: "danger",
              icon: "el-icon-edit",
            },
            label: "開發串接設定",
            handler: row => {
              console.log("the connecting row is ", row);

              this.$router.push(`/si-accounts/${row.id}/app-keys`);
            }
          }
        ]
      },
      filters: [
        {
          value: "",
          prop: "name"
        },
        {
          value: []
        }
      ]
    };
  },
  methods: {
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    getGaaUsers() {
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts`)
        .then(response => {
          this.data = response.data;

          console.log('START GET SI ACCOUNT');
          for (let a of this.data) {
            console.log(a);
            a.createdAt = moment
              .unix(a.createdTs)
              .format("YYYY-MM-DD HH:mm:ss Z");
            a.updatedAt = moment
              .unix(a.updatedTs)
              .format("YYYY-MM-DD HH:mm:ss Z");
          }
          console.log('END GET SI ACCOUNT');
          return response.data;
        });
    }
  },
  mounted() {
    this.getGaaUsers();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
</style>